import { makeEntityScaffold } from '@classpass/saga-tools';
import { trimTimezone, transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

const handler = ({ httpClient }, venueId, scheduleId, occurrenceDate) => {
  const endpoint = URLS.msSchedules.singleScheduleOccurrence(venueId, scheduleId, occurrenceDate);

  return httpClient
    .get(endpoint, VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(transformV2ClientResponse)
    .then(({ startDate, ...rest }) => ({
      ...rest,
      startDate: trimTimezone(startDate),
      startTime: startDate.substring(11, 16),
    }));
};

export default makeEntityScaffold('SAGA.API.FETCH_SCHEDULE_INSTANCE', handler);
